export default (axios, baseURL) => async (clientSid, clientProvider) => {
  const url = `/v2/clients/${encodeURIComponent(clientSid)}/provider/config`;

  const axiosConfig = {
    method: 'PATCH',
    baseURL,
    url,
    data: { ...clientProvider }
  };
  try {
    const axiosResponse = await axios(axiosConfig);

    if (!axiosResponse || !axiosResponse.data || typeof axiosResponse.data !== 'object') {
      throw new Error('Invalid response from gateway');
    }
    return axiosResponse.data;
  } catch (error) {
    if (error.response && error.response.data) {
      return { error: error.response.data };
    }
    throw error;
  }
};
